export default __webpack_public_path__ + "static/media/linkedin-brands.bd7b27a5.svg";